import React, {useEffect, useRef, useState} from 'react'
import Spinner from 'react-bootstrap/Spinner';
import Container from 'react-bootstrap/Container';
import Label from 'react-bootstrap/FormLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import {Link, useLocation, useNavigate} from "react-router-dom";
import Table from 'react-bootstrap/Table';
import ReMultiSelect from 'react-select';
import ReMultiSelectAnimated from 'react-select/animated';
import axios from 'axios';
import Cookies from 'js-cookie';
import {showToast as toast} from '../toastManager';
import alasql from 'alasql';
import errorMessages from '../errorMessages.js';
import delete_icon from '../images/bin.png';
import {MultiSelect} from 'react-multi-select-component';
import {v4 as uuidv4} from 'uuid';
import Accordion from 'react-bootstrap/Accordion';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ImageWithFallback from '../components/ImageFallback';
import Modal from 'react-bootstrap/Modal';
import '../ChatApp.css';

const getPlainText = (html) => {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return (tempDiv.textContent || tempDiv.innerText || '').trim();
};

/** Align with CustomCampaignPersonalization: require every template field to have content before preview/save. */
function validateLandingPageCustomizationFields(campaignData, selected_suggestion) {
    const sections = campaignData?.templates?.customized_sections || [];
    for (let index = 0; index < sections.length; index++) {
        const section = sections[index];
        const suggestion = selected_suggestion?.[index];
        if (section?.type === 'text') {
            const plainText = getPlainText(suggestion);
            if (!plainText) {
                return `Please add ${section.label || `field ${index + 1}`}`;
            }
        } else if (!suggestion || !String(suggestion).trim()) {
            const fieldName = section?.label || `field ${index + 1}`;
            return `Please add ${fieldName}`;
        }
    }
    return null;
}

alasql.fn.ReplaceNullValues = function (val) {
    return ((val === Infinity) || (val === undefined)) ? 0 : val;
}

alasql.fn.Add_Image_HTML_tag = function (val) {
    return `<img src="${val}" alt="Image" width=50 height=50> </img>`;
}

function getMatchTypeLetter(matchType) {
    switch(matchType?.toLowerCase()) {
        case 'exact':
            return 'e';
        case 'phrase':
            return 'p';
        case 'broad':
            return 'b';
        default:
            return matchType || '';
    }
}

function LandingPageOptimization({ViewedPage, shop_domain, app_url}) {
    ViewedPage(28);
    const location = useLocation();
    const navigate = useNavigate();
    const previousPage = location.state?.previousPage || 'campaign-summary';
    const campaignData = location.state?.campaignData;
    const allCamapignTargetings = location.state?.allTargeting ? location.state?.allTargeting : [];
    const _currentUrl = campaignData?.landing_page_urls?.trim() || '';
    const _urlTargetings = (allCamapignTargetings && typeof allCamapignTargetings === 'object' && !Array.isArray(allCamapignTargetings))
        ? (allCamapignTargetings[_currentUrl] || [])
        : (allCamapignTargetings || []);
    const targetingItem = location.state?.targetingItem ? location.state?.targetingItem : {
        id: uuidv4(),
        name: `Untitled Variant`,
        status: 'enabled',
        targeting: [],
        targeting: [],
        lpPreview: ''
    };
    const [generate_preview_contentKey, setGeneratePreviewContentKey] = useState(uuidv4());
    // Add new state and ref for editable title
    const [isEditingName, setIsEditingName] = useState(false);
    const targetAndContentInputRef = useRef(null);
    const [target_and_content_name, setTargetAndContentName] = useState(targetingItem?.name || "Untitled Variant");

    // Add status state and options
    const [status, setStatus] = useState({
        value: targetingItem?.status || 'enabled',
        label: targetingItem?.status ? targetingItem.status.charAt(0).toUpperCase() + targetingItem.status.slice(1) : 'Enabled'
    });
    const statusOptions = [
        {value: 'enabled', label: 'Enabled'},
        {value: 'paused', label: 'Paused'}
    ];

    // Custom styles for dropdowns to ensure they appear above other elements
    const dropdownStyles = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        menu: provided => ({ ...provided, zIndex: 9999 })
    };
    const statusDropdownStyles = {
        ...dropdownStyles,
        control: (provided) => ({
            ...provided,
            minHeight: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            paddingTop: '0px',
            paddingBottom: '0px',
            marginTop: '0px',
            marginBottom: '0px',
            borderRadius: '100px'
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '24px',
            paddingTop: '0px',
            paddingBottom: '0px',
            paddingLeft: '10px',
            paddingRight: '0px',
            lineHeight: 1,
            display: 'flex',
            alignItems: 'center'
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '24px',
            paddingTop: '0px',
            paddingBottom: '0px',
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px'
        }),
        singleValue: (provided) => ({
            ...provided,
            margin: '-4px 0px 0px 0px',
            display: 'flex',
            fontSize: '13px',
            alignItems: 'center',
            lineHeight: 1,
            height: '100%',
            padding: 0
        }),
        indicatorSeparator: () => ({
            display: 'none'
        })
    };

    // Add status change handler
    const handleStatusChange = (selected) => {
        setStatus(selected);
    };

    // Add handlers for title editing
    const handleCampaignNameEdit = () => {
        setIsEditingName(true);
        setTimeout(() => {
            targetAndContentInputRef.current?.focus();
        }, 0);
    };

    const handleCampaignNameChange = (e) => {
        setTargetAndContentName(e.target.value);
    };

    const handleCampaignNameBlur = () => {
        setIsEditingName(false);
        if (!target_and_content_name?.trim()) {
            setTargetAndContentName("Untitled Variation");
        }
    };

    const handleCampaignNameKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleCampaignNameBlur();
        }
    };

    const [loading, setLoading] = useState(true);
    const [analyze_btn_loading, setAnalyzeBtnLoading] = useState(false);
    const [find_more_variation_loading, setFindMoreVariationsLoading] = useState(false);
    const [generate_btn_loading, setGenerateBtnLoading] = useState(false);
    const [show_landing_page, setShowLandingPageURL] = useState(false);
    const [updated_exp_url, setUpdatedExperienceURL] = useState("");
    const [apply_customization_btn_loading, setApplyCustomizeBtnLoading] = useState(false);
    const [show_advanced_options, setShowAdvancedOptions] = useState(false);
    const [show_top_performing_ad_copies, setShowTopPerformingAdCopies] = useState(false);
    const [is_city_personalization_enabled, setIsCityPersonalizationEnabled] = useState(false);
    const [is_zip_code_personalization_enabled, setIsZipCodePersonalizationEnabled] = useState(false);
    const [is_section_personalization_enabled, setIsSectionPersonalizationEnabled] = useState(true);
    const [is_section_rearrangement_enabled, setIsSectionRearrangementEnabled] = useState(false);
    const [spreadsheet_url, setSheetUrl] = useState("");
    const [all_keywords, setAllKeywords] = useState([]);
    const [selected_keywords, setSelectedKeywords] = useState({"label": "", "value": []});
    const [bulk_apply_selected_keywords, setBulkApplySelectedKeywords] = useState([]);
    const [trashed_keywords, setTrashKeywords] = useState(null);
    const [suggestions, setSuggestions] = useState([]);
    const [selected_suggestion, setSelectedSuggestion] = useState(
        targetingItem && targetingItem?.value && targetingItem?.value?.customization && targetingItem?.value?.customization?.length > 0 ? 
        targetingItem?.value?.customization : 
        (campaignData && campaignData?.templates && campaignData.templates?.customized_sections ? 
            campaignData.templates.customized_sections.map((iter) => {
                if (iter.type === 'dropdown' || iter.type === 'form' || iter.type === 'exit_intent') {
                    return iter.options[0].value; // Default to first option for dropdowns and forms
                }
                if (iter.type === 'img' || iter.type === 'image' || iter.type === 'bg_img') {
                    return iter.value || "";
                }
                return ""; // Empty string for text sections
            })
            :
            []
        )
    );

    // Simple word counter helper
    const countWords = (text) => {
        if (!text) return 0;
        return text
            .replace(/<[^>]*>/g, ' ')       // strip HTML tags
            .replace(/&nbsp;/gi, ' ')       // normalize HTML spaces
            .trim()
            .split(/\s+/)
            .filter(Boolean).length;
    };
    const normalizeWhitespace = (value) => {
        if (typeof value !== 'string') return value;
        return value.replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
    };

    // Handle paste events to strip unwanted HTML tags
    const handlePaste = (e, fullIndex) => {
        e.preventDefault();
        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedText = clipboardData.getData('text/plain');
        
        // Get selection
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        
        const range = selection.getRangeAt(0);
        range.deleteContents();
        
        // Insert plain text
        const textNode = document.createTextNode(pastedText);
        range.insertNode(textNode);
        
        // Move cursor to end of inserted text
        range.setStartAfter(textNode);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
        
        // Trigger input event to update state
        const event = new Event('input', { bubbles: true });
        e.currentTarget.dispatchEvent(event);
    };

    // Add state for rearrangement selections
    const [selected_rearrangement, setSelectedRearrangement] = useState(
        targetingItem && targetingItem?.value && targetingItem?.value?.rearrangement && targetingItem?.value?.rearrangement?.length > 0 ? 
        targetingItem?.value?.rearrangement : 
        [] // Initialize as empty array to allow users to add sections even when no data exists
    );

    // Remove the separate dropdownValues state since we'll use selected_suggestion for all values
    const handleDropdownChange = (sectionIndex, value) => {
        let temp_selected_suggestion = [...selected_suggestion];
        temp_selected_suggestion[sectionIndex] = normalizeWhitespace(value);
        setSelectedSuggestion(temp_selected_suggestion);
    };

    // Add rearrangement dropdown change handler
    const handleRearrangementChange = (sectionIndex, value) => {
        let temp_selected_rearrangement = [...selected_rearrangement];
        temp_selected_rearrangement[sectionIndex] = value;
        setSelectedRearrangement(temp_selected_rearrangement);
    };

    // Add handler for deleting rearrangement section
    const handleDeleteRearrangement = (index) => {
        let temp_selected_rearrangement = [...selected_rearrangement];
        temp_selected_rearrangement.splice(index, 1);
        setSelectedRearrangement(temp_selected_rearrangement);
    };

    // Add handler for adding new rearrangement section after a specific index
    const handleAddRearrangement = (index) => {
        const availableOptions = get_rearrangement_options(campaignData);
        if (availableOptions.length > 0) {
            let temp_selected_rearrangement = [...selected_rearrangement];
            // For empty array, insert at index 0, otherwise insert after the specified index
            const insertIndex = temp_selected_rearrangement.length === 0 ? 0 : index + 1;
            temp_selected_rearrangement.splice(insertIndex, 0, availableOptions[0].value);
            setSelectedRearrangement(temp_selected_rearrangement);
        }
    };

    // Asset library (Images) state
    const [showImageLibrary, setShowImageLibrary] = useState(false);
    const [imageAssets, setImageAssets] = useState([]);
    const [imageAssetsLoading, setImageAssetsLoading] = useState(false);
    const [imageAssetTargetIndex, setImageAssetTargetIndex] = useState(null);

    // Persist campaign updates to backend (Redis + Mongo)
    const persistCampaignToStore = async (updatedCampaign) => {
        const campaignsRes = await axios.get(`${app_url}/api/store/personalized_campaigns`, { withCredentials: true });
        let campaigns = campaignsRes?.data?.data || campaignsRes?.data || [];
        if (!Array.isArray(campaigns)) campaigns = [];
        const idx = campaigns.findIndex(c => c?.campaign_id === updatedCampaign?.campaign_id);
        if (idx > -1) {
            campaigns[idx] = updatedCampaign;
        } else {
            campaigns.push(updatedCampaign);
        }
        await axios.put(`${app_url}/api/store/personalized_campaigns`, campaigns, { withCredentials: true });
    };

    const getFilePreviewUrl = (asset) => {
        if (!asset) return '';
        return asset.publicUrl || asset.url || '';
    };

    const openImageAssetLibrary = async (targetIndex) => {
        setImageAssetTargetIndex(targetIndex);
        setShowImageLibrary(true);
        setImageAssetsLoading(true);
        try {
            const res = await axios.post(app_url + "/api/assets/get_all", {
                shop_domain: shop_domain
            });
            const all = res?.data?.data || [];
            const imgs = all.filter(a => a.type === 'Image');
            setImageAssets(imgs);
        } catch (e) {
            setImageAssets([]);
        } finally {
            setImageAssetsLoading(false);
        }
    };

    const handleSelectImageAsset = (asset) => {
        const url = getFilePreviewUrl(asset);
        let temp = [...selected_suggestion];
        if (imageAssetTargetIndex !== null && imageAssetTargetIndex !== undefined) {
            temp[imageAssetTargetIndex] = normalizeWhitespace(url);
            setSelectedSuggestion(temp);
        }
        setShowImageLibrary(false);
        setImageAssetTargetIndex(null);
    };

    const getImageTypeFromUrl = (url) => {
        if (!url) return '';
        try {
            const clean = url.split('?')[0];
            const ext = (clean.split('.').pop() || '').toLowerCase();
            const known = ['jpg','jpeg','png','webp','gif','svg','bmp','avif'];
            if (known.includes(ext)) return ext.toUpperCase();
        } catch (e) {}
        return 'IMAGE';
    };

    const MobileIcon = () => (
        <svg viewBox="0 0 24 24" aria-hidden="true" style={{ width: '14px', height: '14px' }}>
            <rect x="7.5" y="3" width="9" height="18" rx="2.5" ry="2.5" fill="none" stroke="currentColor" strokeWidth="1.8"></rect>
            <circle cx="12" cy="18.5" r="0.9" fill="currentColor"></circle>
        </svg>
    );

    console.log("selected_suggestion",selected_suggestion)
    const [keyword_level_data, setKeywordLevelData] = useState([]);
    const [best_performing_asset_table_data, setBestPerformingAssetTable] = useState([]);
    const [best_performing_asset_raw_data, setBestPerformingAssetRawData] = useState([]);
    // Add state for accordion
    const [activeAccordion, setActiveAccordion] = useState(['0']);

    // Add new state for the new flags
    const [isFormPersonalizationEnabled, setIsFormPersonalizationEnabled] = useState(true);
    const [isExitIntentPersonalizationEnabled, setIsExitIntentPersonalizationEnabled] = useState(true);

    // Rich text helpers
    const editorRefs = useRef({});
    const previousValidHtmlRef = useRef({});
    const wordLimitExceededRef = useRef({});
    const editorInitializedRef = useRef({});
    const [applyAllMap, setApplyAllMap] = useState({});
    const [showToolbarMap, setShowToolbarMap] = useState({});
    const setEditorRef = (idx, el) => {
        if (el) {
            editorRefs.current[idx] = el;
            // Set initial content if not already initialized and element exists
            if (!editorInitializedRef.current[idx] && el) {
                const value = (selected_suggestion && selected_suggestion[idx]) || '';
                if (value && el.innerHTML !== value) {
                    // Use requestAnimationFrame to set content after render, preventing cursor jump
                    requestAnimationFrame(() => {
                        if (el && document.activeElement !== el) {
                            el.innerHTML = value;
                            previousValidHtmlRef.current[idx] = value;
                            editorInitializedRef.current[idx] = true;
                        }
                    });
                } else {
                    editorInitializedRef.current[idx] = true;
                }
            }
        }
    };
    const execCmdOn = (idx, cmd, value = null) => {
        const el = editorRefs.current[idx];
        if (!el) return;
        el.focus();
        try {
            if (applyAllMap[idx]) {
                const range = document.createRange();
                range.selectNodeContents(el);
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            }
            document.execCommand(cmd, false, value);

            // Enforce word limit for this section after command
            const section = campaignData?.templates?.customized_sections?.[idx];
            // const maxWords = section?.max_words || null;
            const maxWords = null;
            const textContent = el.innerText || el.textContent || '';
            const wordCount = countWords(textContent);

            if (maxWords && wordCount > maxWords) {
                const prevHtml = previousValidHtmlRef.current[idx] || '';
                el.innerHTML = prevHtml;
                try {
                    const range = document.createRange();
                    range.selectNodeContents(el);
                    range.collapse(false);
                    const sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                } catch (err) {}
                if (!wordLimitExceededRef.current[idx]) {
                    toast.error(`Max word limit of ${maxWords} exceeded for "${section?.label || 'this section'}".`);
                    wordLimitExceededRef.current[idx] = true;
                }
                return;
            }

            if (maxWords) {
                wordLimitExceededRef.current[idx] = false;
            }

            const html = el.innerHTML;
            const normalizedHtml = normalizeWhitespace(html);
            let temp = [...selected_suggestion];
            temp[idx] = normalizedHtml;
            setSelectedSuggestion(temp);
            previousValidHtmlRef.current[idx] = normalizedHtml;
        } catch(e) {}
    };
    const toggleApplyAll = (idx) => setApplyAllMap(prev => ({...prev, [idx]: !prev[idx]}));
    const toggleToolbar = (idx, show) => setShowToolbarMap(prev => ({...prev, [idx]: (show === undefined ? !prev[idx] : show)}));

    // Keep contenteditable elements in sync with selected_suggestion
    // without letting React re-render their innerHTML on every keystroke
    useEffect(() => {
        const refs = editorRefs.current || {};
        Object.keys(refs).forEach((key) => {
            const el = refs[key];
            if (!el) return;
            // Do not overwrite while user is actively typing in this editor
            if (document.activeElement === el) return;
            const value = (selected_suggestion && selected_suggestion[key]) || '';
            // Only update if content is different and editor has been initialized
            if (el.innerHTML !== value && editorInitializedRef.current[key]) {
                el.innerHTML = value;
                previousValidHtmlRef.current[key] = value;
            }
        });
    }, [selected_suggestion]);

    // Pre-populate bulk apply table with targetings from campaignData.targeting_and_content
    useEffect(() => {
        if (all_keywords && all_keywords.length > 0 && bulk_apply_selected_keywords.length === 0) {
            // Flatten all targetings from all targeting_and_content
            const allTargetings = targetingItem?.targeting ? targetingItem.targeting.map((iter) => iter.label) : [];

            // Find matching keyword objects in all_keywords by full label
            const matchedKeywords = all_keywords.filter(kw => {
                const fullLabel = `${kw.value[0].keyword_text} (${kw.value[0].match_type} | ${kw.value[0].ad_group_name} | ${kw.value[0].campaign_name})`;
                return allTargetings.includes(fullLabel);
            });

            // Format for MultiSelect
            const formatted = matchedKeywords.map(val => ({
                value: val.value,
                label: `${val.value[0].keyword_text} (${val.value[0].match_type} | ${val.value[0].ad_group_name} | ${val.value[0].campaign_name})`
            }));

            if (targetingItem?.targeting && Array.isArray(targetingItem?.targeting) && targetingItem?.targeting.length > 0) {
                setBulkApplySelectedKeywords(targetingItem?.targeting);
            }
        }
    }, [all_keywords, campaignData]);

    useEffect(() => {
        console.log("In Report", shop_domain)
        setLoading(true);
        try {
            if (Cookies.get('shop')) {
                // Facebook Loader data
                var created_at_max = new Date();
                created_at_max.setDate(created_at_max.getDate() - 1);
                var created_at_min = new Date(new Date().setDate(created_at_max.getDate() - 90));
                axios.post(app_url + "/api/google/get_landing_page_optimization_data", {
                    shop_domain: shop_domain,
                    date_start: formatDate(created_at_min),
                    date_end: formatDate(created_at_max),
                    func_call_type: "redis",
                }, {withCredentials: true})
                    .then(res => res.data)
                    .then(data => {
                        console.log(data)
                        let keyword_level_data = data["data"]["lp_keywords_data"];

                        setBestPerformingAssetRawData(data["data"]["landing_page_best_headline_description_data"]);

                        // Settings Location Personalization
                        setIsCityPersonalizationEnabled(data && data?.data && data?.data?.is_city_personalization_enabled ? data["data"]["is_city_personalization_enabled"] : false);
                        setIsZipCodePersonalizationEnabled(data && data?.data && data?.data?.is_zip_code_personalization_enabled ? data["data"]["is_zip_code_personalization_enabled"] : false);
                        setIsSectionPersonalizationEnabled(data && data?.data && data?.data?.is_section_personalization_enabled !== undefined ? data["data"]["is_section_personalization_enabled"] : true);
                        setIsSectionRearrangementEnabled(data && data?.data && data?.data?.is_section_rearrangement_enabled !== undefined ? data["data"]["is_section_rearrangement_enabled"] : false);
                        setIsFormPersonalizationEnabled(data && data?.data && data?.data?.is_form_personalization_enabled !== undefined ? data["data"]["is_form_personalization_enabled"] : true);
                        setIsExitIntentPersonalizationEnabled(data && data?.data && data?.data?.is_exit_intent_personalization_enabled !== undefined ? data["data"]["is_exit_intent_personalization_enabled"] : true);

                        setKeywordLevelData(keyword_level_data);
                        let temp_all_keywords = get_all_keywords_for_analysis_section(keyword_level_data)
                        temp_all_keywords = temp_all_keywords.filter(val => {
                            const kw = val?.["value"]?.[0];
                            if (!kw || !kw["campaign_id"]) return true;
                            const kwKey = `${kw["campaign_id"]}-${kw["ad_group_id"]}-${kw["keyword_text"]}-${getMatchTypeLetter(kw["match_type"])}`;
                            return !_urlTargetings.includes(kwKey);
                        })
                        if (targetingItem?.targeting && Array.isArray(targetingItem?.targeting) && targetingItem?.targeting.length > 0) {
                            temp_all_keywords = [...targetingItem.targeting,...temp_all_keywords]
                        }
                        setAllKeywords((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords : [])
                        setSelectedKeywords((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords[0] : {
                            "label": "",
                            "value": []
                        })
                        setAnalyzeBtnLoading(false);
                        setGenerateBtnLoading(false);
                        setShowLandingPageURL(false);
                        setLoading(false)
                    })
                    .catch(err => {
                        setIsSectionRearrangementEnabled(false);
                        setLoading(false)
                        toast.error(`${errorMessages["DATA_PARSING_ERROR"]["title"]}`);
                        console.log(err);
                    })
            }
        } catch (error) {
            setIsSectionRearrangementEnabled(false);
            setLoading(false)
            toast.error(`${errorMessages["DATA_LOAD_ERROR"]["title"]}`);
            console.log(error);
        }

    }, [app_url, shop_domain, campaignData]);

    const handleCustomizePageSubmit = (is_drafted) => {
        // If saved then do not update the feature flag
        if(!is_drafted){
            return null;
        }
        setGenerateBtnLoading(true);
        console.log(selected_suggestion)
        const customizationErr = validateLandingPageCustomizationFields(campaignData, selected_suggestion);
        if (customizationErr) {
            toast.error(customizationErr);
            if (!is_drafted) {
                setApplyCustomizeBtnLoading(false);
            }
            setGenerateBtnLoading(false);
            return;
        }

        // Check keyword uniqueness
        let keywordsToCheck = [];
        if (is_drafted) {
            keywordsToCheck = [selected_keywords];
        } else {
            keywordsToCheck = bulk_apply_selected_keywords;
        }

        let temp_feature_flag_keys = generate_preview_contentKey;
        console.log("Temp Feature Flag Keys", temp_feature_flag_keys)
        const customizationPayload = (campaignData?.templates?.customized_sections || []).map((section, idx) => {
            const val = selected_suggestion?.[idx];
            if (val !== undefined && val !== null && String(val).length > 0) return val;
            if (section.type === 'dropdown' || section.type === 'form' || section.type === 'exit_intent') {
                return section.options?.[0]?.value || '';
            }
            return section.value || '';
        });
        const rearrangementPayload = is_section_rearrangement_enabled
            ? (selected_rearrangement || []).map((section) => {return {
                section_id: section?.section_id, 
                section_name: section?.section_name, 
                section_query_selector: section?.section_query_selector,
                parent_query_selector: section?.parent_query_selector,
                section_category: section?.section_category,
                section_sub_category: section?.section_sub_category,
                section_rearrangement: section?.section_rearrangement
            }})
            : {};
        axios.post(app_url + "/api/cux/generate-preview", {
            "landing_page_url": campaignData.landing_page_urls,
            "key": temp_feature_flag_keys,
            "value": {template_id: campaignData?.templates?.id || "", customization: customizationPayload, rearrangement: rearrangementPayload}
        }, {withCredentials: true})
            .then(res => res.data)
            .then(data => {
                if (!is_drafted) {
                    setApplyCustomizeBtnLoading(false);
                }
                setGenerateBtnLoading(false);
            })
            .catch(err => {
                toast.error(`${errorMessages["AI_GENERATION_ERROR"]["title"]}`);
                if (!is_drafted) {
                    setApplyCustomizeBtnLoading(false);
                }
                setGenerateBtnLoading(false);
                console.log(err);
            })
    }

    const handleSaveDescriptionToSheet = async (is_drafted) => {
        if(!is_drafted){
            setApplyCustomizeBtnLoading(true);
        }
        if (!target_and_content_name?.trim()) {
            toast.error(`Please enter a variant name.`);
            setApplyCustomizeBtnLoading(false);
            return;
        }
        if (!selected_suggestion || selected_suggestion.length === 0) {
            toast.error(`Please add personalized text.`);
            setApplyCustomizeBtnLoading(false);
            return;
        }

        const customizationErr = validateLandingPageCustomizationFields(campaignData, selected_suggestion);
        if (customizationErr) {
            toast.error(customizationErr);
            setApplyCustomizeBtnLoading(false);
            return;
        }

        if (is_drafted && keyword_level_data && keyword_level_data.length > 0) {
            if (!selected_keywords?.value || selected_keywords.value.length === 0) {
                toast.error(`Please select a keyword.`);
                setApplyCustomizeBtnLoading(false);
                return;
            }
        }

        const textSections = campaignData?.templates?.customized_sections?.filter(section => section.type === 'text') || [];
        for (let index = 0; index < textSections.length; index++) {
            const sectionIndex = campaignData.templates.customized_sections.findIndex(s => s === textSections[index]);
            const suggestion_iter = selected_suggestion[sectionIndex];
            let loc_personalization_dict = check_loc_personalization(suggestion_iter);
            if (loc_personalization_dict["is_loc_personalized"]) {
                if ((loc_personalization_dict["loc_personalization_type"] === "city") && (is_city_personalization_enabled === false)) {
                    toast.error(`Please enable City personalization by going to Settings > Location Personalization`);
                    setApplyCustomizeBtnLoading(false);
                    return;
                }
                if ((loc_personalization_dict["loc_personalization_type"] === "zip_code") && (is_zip_code_personalization_enabled === false)) {
                    toast.error(`Please enable Zip code personalization by going to Settings > Location Personalization`);
                    setApplyCustomizeBtnLoading(false);
                    return;
                }
            }
        }

        // Check keyword uniqueness
        let keywordsToCheck = [];
        if (is_drafted) {
            keywordsToCheck = [selected_keywords];
        } else {
            keywordsToCheck = bulk_apply_selected_keywords;
        }

        try {
            if (Cookies.get('shop')) {
                handleCustomizePageSubmit(is_drafted);
                let customized_exp_sheet_data = []
                let updatedCampaignData = campaignData;

                if (is_drafted) {
                    customized_exp_sheet_data = selected_keywords["value"].map((keyword_iter) => {
                        // For draft mode, use targeting_and_content.id
                        let updated_exp_url = campaignData.landing_page_urls + "?sxi_content=" + generate_preview_contentKey;
                        
                        // Map selected_suggestion to use labels for dropdowns
                        const mappedSuggestions = selected_suggestion.map((value, index) => {
                            const section = campaignData.templates.customized_sections[index];
                            if (section && (section.type === 'dropdown' || section.type === 'form' || section.type === 'exit_intent')) {
                                // Find the option that matches this value and return its label
                                const option = section.options.find(opt => opt.value === value);
                                return option ? option.label : value;
                            }
                            return value;
                        });

                        return [
                            formatDate(new Date()),
                            target_and_content_name,
                            status.label,
                            keyword_iter["campaign_name"],
                            keyword_iter["ad_group_name"],
                            keyword_iter["keyword_text"],
                            keyword_iter["match_type"],
                            campaignData.landing_page_urls,
                            ...mappedSuggestions,
                            encodeURI(updated_exp_url)
                        ]
                    });
                } else {
                    if (bulk_apply_selected_keywords) {
                        // Calculate new lpPreview URL based on selected_keywords and draft suffix
                        const firstSelectedKeywordInfo = selected_keywords?.value?.[0];
                        const previewIdentifier = firstSelectedKeywordInfo
                            ? `${firstSelectedKeywordInfo["campaign_id"] || ""}-${firstSelectedKeywordInfo["ad_group_id"] || ""}-${firstSelectedKeywordInfo["keyword_text"] || ""}-${getMatchTypeLetter(firstSelectedKeywordInfo["match_type"])} (draft_${shop_domain.replace(".myshopify.com", "")})`
                            : '';
                        const finalLpPreviewUrl = previewIdentifier
                            ? encodeURI(campaignData.landing_page_urls + "?sxi_content=" + previewIdentifier)
                            : '';

                        // Calculate new targeting array including selected_keywords.label
                        const currentBulkLabels = bulk_apply_selected_keywords.map(k => k);
                        const allTargetingLabels = new Set(currentBulkLabels);
                        const finalTargetingArray = Array.from(allTargetingLabels);
                        
                        customized_exp_sheet_data = bulk_apply_selected_keywords.map((keywordOption) => {
                            return keywordOption.value.map((keyword_iter) => {
                                let updated_exp_url = campaignData.landing_page_urls + "?sxi_content=" + (is_drafted ? `${keyword_iter["campaign_id"] || ""}-${keyword_iter["ad_group_id"] || ""}-${keyword_iter["keyword_text"] || ""}-${getMatchTypeLetter(keyword_iter["match_type"])} (draft_${shop_domain.replace(".myshopify.com", "")})` : `${keyword_iter["campaign_id"] || ""}-${keyword_iter["ad_group_id"] || ""}-${keyword_iter["keyword_text"] || ""}-${getMatchTypeLetter(keyword_iter["match_type"])}`);
                                
                                // Map selected_suggestion to use labels for dropdowns
                                const mappedSuggestions = selected_suggestion.map((value, index) => {
                                    const section = campaignData.templates.customized_sections[index];
                                    if (section && (section.type === 'dropdown' || section.type === 'form' || section.type === 'exit_intent')) {
                                        // Find the option that matches this value and return its label
                                        const option = section.options.find(opt => opt.value === value);
                                        return option ? option.label : value;
                                    }
                                    return value;
                                });

                                return [
                                    formatDate(new Date()),
                                    target_and_content_name,
                                    status.label,
                                    keyword_iter["campaign_name"],
                                    keyword_iter["ad_group_name"],
                                    keyword_iter["keyword_text"],
                                    keyword_iter["match_type"],
                                    campaignData.landing_page_urls,
                                    ...mappedSuggestions,
                                    encodeURI(updated_exp_url)
                                ]
                            });
                        }).flat();
                        console.log("Customized Exp Sheet Data", customized_exp_sheet_data)

                        // Check if we're editing an existing targeting item
                        if (targetingItem && targetingItem.id) {
                            // Update existing targeting item
                            const updatedTargeting = campaignData.targeting_and_content.filter(item => item.id !== targetingItem.id);
                            updatedCampaignData = {
                                ...campaignData,
                                targeting_and_content: [
                                    ...(updatedTargeting || []),
                                    {
                                        id: targetingItem.id,
                                        name: target_and_content_name || 'Untitled Variant',
                                        status: status.value,
                                        targeting: finalTargetingArray,
                                        value: {
                                            customization: selected_suggestion,
                                            rearrangement: is_section_rearrangement_enabled ? selected_rearrangement : []
                                        },
                                        lpPreview: campaignData.landing_page_urls + "?sxi_content=" + generate_preview_contentKey,
                                        preview_targeting: generate_preview_contentKey
                                    }
                                ]
                            };
                        } else {
                            // Create new targeting data only if we're not editing
                            const newId = uuidv4();
                            const newTargeting = {
                                id: newId,
                                name: target_and_content_name || 'Untitled Variant',
                                status: status.value,
                                targeting: finalTargetingArray,
                                value: {
                                    customization: selected_suggestion,
                                    rearrangement: is_section_rearrangement_enabled ? selected_rearrangement : []
                                },
                                lpPreview: campaignData.landing_page_urls + "?sxi_content=" + generate_preview_contentKey,
                                preview_targeting: generate_preview_contentKey,
                            };
                            // Update campaign data with new targeting
                            updatedCampaignData = {
                                ...campaignData,
                                targeting_and_content: [
                                    ...(campaignData?.targeting_and_content || []),
                                    newTargeting
                                ]
                            };
                        }
                    }
                }
                console.log("Updated Campaign Data", updatedCampaignData)

                // If paused, cleanup GrowthBook entries for this variant before publish
                // if (status?.value === 'paused') {
                //     const variantKeys = [];
                //     (updatedCampaignData?.targeting_and_content || []).forEach(tc => {
                //         if (tc?.id !== targetingItem?.id) return;
                //         (tc?.targeting || []).forEach(t => {
                //             if (!t) return;
                //             if (typeof t === 'string') variantKeys.push(t);
                //             else if (t.label) variantKeys.push(t.label);
                //             else if (t.value) variantKeys.push(t.value);
                //         });
                //     });
                //     try {
                //         await axios.post(`${app_url}/api/store/personalized_campaigns/cleanup`, {
                //             campaign_id: updatedCampaignData?.campaign_id,
                //             variant_ids: [targetingItem?.id],
                //             variant_keys: [...new Set(variantKeys.filter(Boolean))],
                //             remove_campaign: false
                //         }, { withCredentials: true });
                //     } catch (err) {
                //         console.error('Error cleaning GrowthBook entries for paused variant', err);
                //         // continue to publish even if cleanup fails
                //     }
                // }

                // Publish (replace prior save flow) when not draft
                if (!is_drafted) {
                    try {
                        await axios.post(`${app_url}/api/cux/publish-campaign`, { campaignData: updatedCampaignData }, { withCredentials: true });
                        setApplyCustomizeBtnLoading(false);
                        setShowLandingPageURL(true);
                        console.log("Updated Campaign Data", updatedCampaignData)
                        const bulk_kw_keys = bulk_apply_selected_keywords
                            ? bulk_apply_selected_keywords.flatMap(kw => kw.value.filter(k => k?.["campaign_id"]).map(k => `${k["campaign_id"]}-${k["ad_group_id"]}-${k["keyword_text"]}-${getMatchTypeLetter(k["match_type"])}`))
                            : [];
                        navigate('/personalization-campaign', {
                            state: {
                                campaignData: updatedCampaignData,
                                allTargeting: {
                                    ...allCamapignTargetings,
                                    [_currentUrl]: [...new Set([..._urlTargetings, ...bulk_kw_keys, generate_preview_contentKey.toLowerCase()])]
                                }
                            }
                        });
                    } catch (err) {
                        console.error('Error publishing campaign', err);
                        setApplyCustomizeBtnLoading(false);
                        toast.error(errorMessages["DATA_SAVE_ERROR"]?.title || "Failed to publish campaign");
                    }
                } else {
                    // For draft mode, just update the UI state
                    setUpdatedExperienceURL(encodeURI(
                        campaignData.landing_page_urls +
                        "?sxi_content=" +
                        `${selected_keywords["value"][0]["keyword_text"]} (draft_${shop_domain.replace(".myshopify.com", "")})`
                    ));
                    setApplyCustomizeBtnLoading(false);
                    setShowLandingPageURL(true);
                }
            }
        } catch (err) {
            setApplyCustomizeBtnLoading(false);
            toast.error(`${errorMessages["SHEET_UPLOAD_FAILED"]["title"]}`);
            console.log(err)
        }
    }

    const handleAnalyze = (e) => {
        e.preventDefault();
        setShowLandingPageURL(false)
        setAnalyzeBtnLoading(true);

        try {
            // Adding best performing assest of selected keyword adgroup
            let temp_table_data = best_performing_asset_raw_data.filter((iter) => iter["ad_group_id"] === selected_keywords["value"][0]["ad_group_id"])[0];
            setBestPerformingAssetTable(temp_table_data)

            // Getting suggestions from chatbot
            const customizedSections = campaignData?.templates?.customized_sections;
            const textSections = customizedSections ? customizedSections.filter(section => section.type === 'text') : [];
            const headers_array = textSections ? textSections.map(s => s.label) : ["Page Descriptions"];
            let new_message = `Keyword : ${selected_keywords["label"]} \n\n`;
            if (headers_array && headers_array.length > 0) {
                new_message += `Using above details, Provide 5 ad copies. Make sure each copies follows intent of above keyword. And each copies uses a different communication theme. ${campaignData?.templates?.context || ""}. Response should in json format.\n\nStrictly follow JSON Format, {"copies 1": [${headers_array.map(header => `"${header}"`).join(", ")}], "copies 2": [${headers_array.map(header => `"${header}"`).join(", ")}]}. \n\n`;
            } else {
                // Fallback prompt if template doesn't have one (though it should)
                new_message += `Using above details, Provide 5 ad copies description in less than 120 characters. Make sure description follows intent of above keyword. And each description uses a different communication theme. Response should in json format.\n\nStrictly follow JSON Format, {"Copies 1":["Description 1"],"Copies 2":["Description 2"],"Copies 3":["Description 3"],"Copies 4":["Description 4"],"Copies 5":["Description 5"]}. \n\n`;
            }

            axios.post(app_url + "/chats", {
                new_message: new_message,
                old_message: [],
                format: "json_object"
            }, {withCredentials: true})
                .then(res => res.data)
                .then(data => {
                    console.log(JSON.parse(data.data))
                    let chatbot_res = JSON.parse(data.data);
                    let temp_suggestions_keys = Object.keys(chatbot_res);
                    let new_suggestions_state_value = [];

                    if (customizedSections) {
                        // chatbot_res[key] is an array of values for one "Copy", e.g., ["Headline text", "Description text"]
                        const data_rows = temp_suggestions_keys.map(key => chatbot_res[key]);
                        new_suggestions_state_value = [headers_array, ...data_rows];
                    } else { // Fallback if no customized_sections (should ideally not happen if template is present)
                        const data_rows = temp_suggestions_keys.map(key => chatbot_res[key]); // Assuming chatbot_res[key] is still an array
                        new_suggestions_state_value = [headers_array, ...data_rows];
                    }

                    console.log("Suggestion structure for state:", new_suggestions_state_value)
                    setSuggestions(new_suggestions_state_value);
                    setAnalyzeBtnLoading(false)
                })
                .catch(err => {
                    setAnalyzeBtnLoading(false)
                    toast.error(`${errorMessages["AI_GENERATION_ERROR"]["title"]}`);
                    console.log(err);
                })
        } catch (error) {
            toast.error(`${errorMessages["AI_GENERATION_ERROR"]["title"]}`);
            setAnalyzeBtnLoading(false)
            console.log(error);
        }
    }


    const handleFindMoreVariations = (e) => {
        e.preventDefault();
        setFindMoreVariationsLoading(true);
        try {
            const customizedSections = campaignData?.templates?.customized_sections;
            const textSections = customizedSections ? customizedSections.filter(section => section.type === 'text') : [];
            const headers_array = textSections ? textSections.map(s => s.label) : ["Page Descriptions"];
            let new_message = `Keyword : ${selected_keywords["label"]} \n\n`;
            if (headers_array && headers_array.length > 0) {
                new_message += `Using above details, Provide 5 ad copies. Make sure each copies follows intent of above keyword. And each copies uses a different communication theme. ${campaignData?.templates?.context || ""}. Response should in json format.\n\nStrictly follow JSON Format, {"copies 1": [${headers_array.map(header => `"${header}"`).join(", ")}], "copies 2": [${headers_array.map(header => `"${header}"`).join(", ")}]}. \n\n`;
            } else {
                // Fallback prompt if template doesn't have one (though it should)
                new_message += `Using above details, Provide 5 ad copies description in less than 120 characters. Make sure description follows intent of above keyword. And each description uses a different communication theme. Response should in json format.\n\nStrictly follow JSON Format, {"Copies 1":["Description 1"],"Copies 2":["Description 2"],"Copies 3":["Description 3"],"Copies 4":["Description 4"],"Copies 5":["Description 5"]}. \n\n`;
            }


            axios.post(app_url + "/chats", {
                new_message: new_message,
                old_message: [],
                format: "json_object"
            }, {withCredentials: true})
                .then(res => res.data)
                .then(data => {
                    console.log(JSON.parse(data.data))
                    let chatbot_res = JSON.parse(data.data);
                    let temp_suggestions_keys = Object.keys(JSON.parse(data.data));
                    let temp_new_suggestions_rows = [];

                    // Use template's customized_sections to map response
                    const customizedSections = campaignData?.templates?.customized_sections;

                    if (customizedSections) {
                        // Assuming chatbot_res[key] is an array of values for one "Copy"
                        temp_new_suggestions_rows = temp_suggestions_keys.map(key => chatbot_res[key]);
                    } else { // Fallback
                        temp_new_suggestions_rows = JSON.parse(data.data)[temp_suggestions_keys[0]].map((val) => {
                            return [val]
                        });
                    }

                    console.log("New Suggestions", temp_new_suggestions_rows)
                    // Append new rows to existing suggestions (excluding header row)
                    if (suggestions.length > 0) {
                        setSuggestions([...suggestions, ...temp_new_suggestions_rows]);
                    } else {
                        // If suggestions was empty, create it with headers
                        const headers = customizedSections ? customizedSections.map(s => s.label) : ["Page Descriptions"];
                        setSuggestions([headers, ...temp_new_suggestions_rows]);
                    }
                    setFindMoreVariationsLoading(false)
                })
                .catch(err => {
                    setFindMoreVariationsLoading(false)
                    toast.error(`${errorMessages["AI_GENERATION_ERROR"]["title"]}`);
                    console.log(err);
                })
        } catch (error) {
            toast.error(`${errorMessages["AI_GENERATION_ERROR"]["title"]}`);
            setFindMoreVariationsLoading(false)
            console.log(error);
        }
    }

    const handleBack = () => {
        console.log("Updated Campaign Data", campaignData)
        if (previousPage === 'personalization-campaign') {
            const bulk_kw_keys = bulk_apply_selected_keywords
                ? bulk_apply_selected_keywords.flatMap(kw => kw.value.map(k => `${k["campaign_id"]}-${k["ad_group_id"]}-${k["keyword_text"]}-${getMatchTypeLetter(k["match_type"])}`))
                : [];
            navigate('/personalization-campaign', {state: {campaignData: campaignData, allTargeting: {...allCamapignTargetings, [_currentUrl]: [...new Set([..._urlTargetings, ...bulk_kw_keys, generate_preview_contentKey.toLowerCase()])]}}});
        } else {
            navigate('/campaign-summary');
        }
    };

    // Define width calculation variables for responsive UI
    const textSections = campaignData?.templates?.customized_sections?.filter(s => s.type === 'text') || [];
    const textSectionsCount = textSections.length;
    const textSectionWidth = textSectionsCount >= 3 ? "calc(100% / 3)" : (textSectionsCount === 2 ? "50%" : "100%");

    // Combined content sections (text + images) to preserve order; laid out with flex-wrap (no horizontal scroll)
    const contentSectionsForRow = campaignData?.templates?.customized_sections?.filter(s => (s.type === 'text' || s.type === 'img' || s.type === 'image' || s.type === 'bg_img')) || [];

    const suggestionsHeaders = suggestions[0] || [];
    const suggestionsColCount = suggestionsHeaders.length;
    const suggestionsColWidth = suggestionsColCount >= 3 ? "calc(100% / 3)" : (suggestionsColCount === 2 ? "50%" : "100%");

    const canShowSection =
        is_section_personalization_enabled &&
        campaignData &&
        campaignData?.templates &&
        campaignData?.templates?.customized_sections &&
        campaignData.templates.customized_sections.filter(section => section.type === 'dropdown').length > 0;

    const canShowForm =
        isFormPersonalizationEnabled &&
        campaignData?.templates?.customized_sections?.some(section => section.type === 'form');

    const canShowExitIntent =
        isExitIntentPersonalizationEnabled &&
        campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent');

    const canShowRearrange =
        is_section_rearrangement_enabled && campaignData?.sections_rearrangement;

    const rearrangeEventKey = '4';
    const previewEventKey = canShowRearrange ? '5' : '4';
    const bulkApplyEventKey = canShowRearrange ? '6' : '5';

    const getVisibleTabs = () => {
        const tabs = ['0'];
        if (canShowSection) tabs.push('1');
        if (canShowForm) tabs.push('2');
        if (canShowExitIntent) tabs.push('3');
        if (canShowRearrange) tabs.push(rearrangeEventKey);
        tabs.push(previewEventKey);
        tabs.push(bulkApplyEventKey);
        return tabs;
    };

    return (
        <div className='main-container'>
            {!shop_domain ?
                <div className='go_to_shopify_admin_div'>
                    <h5 style={{display: 'inline-block'}}>!! Go to Shopify Admin and open our app !!</h5>
                </div>
                :
                <>
                    {!loading ?
                        <>
                            <div
                                className='p-3 custom-campaign-personalization-title'
                                style={{
                                    backgroundColor: 'white',
                                    border: '1px solid #EAECF0',
                                    borderRadius: '12px',
                                    boxSizing: 'border-box'
                                }}
                            >
                                <div className="d-flex justify-content-between align-items-start w-100">
                                    <div className="d-flex flex-column">
                                        <div className="d-flex align-items-center gap-2">
                                            {isEditingName ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={target_and_content_name}
                                                    onChange={handleCampaignNameChange}
                                                    onBlur={handleCampaignNameBlur}
                                                    onKeyDown={handleCampaignNameKeyDown}
                                                    ref={targetAndContentInputRef}
                                                    style={{
                                                        fontSize: '1.25rem',
                                                        fontWeight: 'bold',
                                                        width: 'auto',
                                                        minWidth: '180px'
                                                    }}
                                                />
                                            ) : (
                                                <OverlayTrigger
                                                    placement="bottom"
                                                    overlay={
                                                        <Tooltip id="lpo-title-description-tooltip" className="sxi-campaign-edit-tooltip single-line-tooltip" style={{marginLeft: '4rem'}}>
                                                            Optimize your landing page experience with AI suggestions
                                                        </Tooltip>
                                                    }
                                                >
                                                    <h2 style={{
                                                        marginBottom: 0,
                                                        fontSize: '1.25rem',
                                                        fontWeight: 'bold',
                                                        cursor: 'help'
                                                    }}>{target_and_content_name}</h2>
                                                </OverlayTrigger>
                                            )}

                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="lpo-title-edit-tooltip" className="sxi-campaign-edit-tooltip">
                                                        Edit the title by clicking on the icon
                                                    </Tooltip>
                                                }
                                            >
                                                <button
                                                    className="btn btn-sm btn-link p-0"
                                                    onClick={handleCampaignNameEdit}
                                                >
                                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V17.2C2 18.8802 2 19.7202 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.5C22.3284 4.67157 22.3284 3.32843 21.5 2.5C20.6716 1.67157 19.3284 1.67157 18.5 2.5L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1575 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z" stroke="#AAAAAA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                            </OverlayTrigger>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-start">
                                        <span className='campaign-tag-new me-2'>{campaignData?.category || 'Landing Page Optimization'}</span>
                                        <span className="fw-bold me-2" style={{fontSize: '14px'}}>Status</span>
                                        <div style={{width: '120px'}}>
                                            <ReMultiSelect
                                                closeMenuOnSelect={true}
                                                components={ReMultiSelectAnimated()}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={statusDropdownStyles}
                                                value={status}
                                                options={statusOptions}
                                                onChange={handleStatusChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Container className='my-4'>
                                <div className="tab-container setVisible mt-4">
                                    <div className="tab-navigation">
                                        <button
                                            type="button"
                                            className={`tab-button ${activeAccordion.includes('0') ? 'active' : ''}`}
                                            onClick={() => setActiveAccordion(['0'])}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" className="tab-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 16.5C7.9625 16.5 6.9875 16.303 6.075 15.909C5.1625 15.515 4.36875 14.9808 3.69375 14.3063C3.01875 13.6318 2.4845 12.838 2.091 11.925C1.6975 11.012 1.5005 10.037 1.5 9C1.4995 7.963 1.6965 6.988 2.091 6.075C2.4855 5.162 3.01975 4.36825 3.69375 3.69375C4.36775 3.01925 5.1615 2.485 6.075 2.091C6.9885 1.697 7.9635 1.5 9 1.5C10.0365 1.5 11.0115 1.697 11.925 2.091C12.8385 2.485 13.6323 3.01925 14.3063 3.69375C14.9803 4.36825 15.5148 5.162 15.9098 6.075C16.3048 6.988 16.5015 7.963 16.5 9C16.4985 10.037 16.3015 11.012 15.909 11.925C15.5165 12.838 14.9823 13.6318 14.3063 14.3063C13.6303 14.9808 12.8365 15.5152 11.925 15.9097C11.0135 16.3042 10.0385 16.501 9 16.5ZM9 15C10.675 15 12.0938 14.4187 13.2563 13.2562C14.4187 12.0937 15 10.675 15 9C15 7.325 14.4187 5.90625 13.2563 4.74375C12.0938 3.58125 10.675 3 9 3C7.325 3 5.90625 3.58125 4.74375 4.74375C3.58125 5.90625 3 7.325 3 9C3 10.675 3.58125 12.0937 4.74375 13.2562C5.90625 14.4187 7.325 15 9 15ZM9 13.5C7.75 13.5 6.6875 13.0625 5.8125 12.1875C4.9375 11.3125 4.5 10.25 4.5 9C4.5 7.75 4.9375 6.6875 5.8125 5.8125C6.6875 4.9375 7.75 4.5 9 4.5C10.25 4.5 11.3125 4.9375 12.1875 5.8125C13.0625 6.6875 13.5 7.75 13.5 9C13.5 10.25 13.0625 11.3125 12.1875 12.1875C11.3125 13.0625 10.25 13.5 9 13.5ZM9 12C9.825 12 10.5313 11.7063 11.1188 11.1187C11.7063 10.5312 12 9.825 12 9C12 8.175 11.7063 7.46875 11.1188 6.88125C10.5313 6.29375 9.825 6 9 6C8.175 6 7.46875 6.29375 6.88125 6.88125C6.29375 7.46875 6 8.175 6 9C6 9.825 6.29375 10.5312 6.88125 11.1187C7.46875 11.7063 8.175 12 9 12ZM9 10.5C8.5875 10.5 8.2345 10.3533 7.941 10.0597C7.6475 9.76625 7.5005 9.413 7.5 9C7.4995 8.587 7.6465 8.234 7.941 7.941C8.2355 7.648 8.5885 7.501 9 7.5C9.4115 7.499 9.76475 7.646 10.0598 7.941C10.3548 8.236 10.5015 8.589 10.5 9C10.4985 9.411 10.3518 9.76425 10.0598 10.0597C9.76775 10.3553 9.4145 10.502 9 10.5Z" fill="currentColor"/>
                                            </svg>
                                            Select and Modify Content
                                        </button>

                                        {canShowSection && (
                                            <button
                                                type="button"
                                                className={`tab-button ${activeAccordion.includes('1') ? 'active' : ''}`}
                                                onClick={() => setActiveAccordion(['1'])}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 16 18" fill="currentColor" className="tab-icon" aria-hidden="true">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M2.56681 0.5C2.12479 0.5 1.70086 0.675595 1.3883 0.988155C1.07574 1.30072 0.900146 1.72464 0.900146 2.16667V13.8333C0.900146 14.2754 1.07574 14.6993 1.3883 15.0118C1.70086 15.3244 2.12479 15.5 2.56681 15.5H14.2335C14.6755 15.5 15.0994 15.3244 15.412 15.0118C15.7246 14.6993 15.9001 14.2754 15.9001 13.8333V2.16667C15.9001 1.72464 15.7246 1.30072 15.412 0.988155C15.0994 0.675595 14.6755 0.5 14.2335 0.5H2.56681ZM7.56681 2.16667H2.56681V6.33333H7.56681V2.16667ZM2.56681 8H7.56681C8.00884 8 8.43276 7.8244 8.74532 7.51184C9.05788 7.19928 9.23348 6.77536 9.23348 6.33333V2.16667H14.2335V13.8333H2.56681V8Z" />
                                                </svg>
                                                Select Section
                                            </button>
                                        )}

                                        {canShowForm && (
                                            <button
                                                type="button"
                                                className={`tab-button ${activeAccordion.includes('2') ? 'active' : ''}`}
                                                onClick={() => setActiveAccordion(['2'])}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="tab-icon" aria-hidden="true">
                                                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                                                </svg>
                                                Select Form
                                            </button>
                                        )}

                                        {canShowExitIntent && (
                                            <button
                                                type="button"
                                                className={`tab-button ${activeAccordion.includes('3') ? 'active' : ''}`}
                                                onClick={() => setActiveAccordion(['3'])}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="tab-icon" aria-hidden="true">
                                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                </svg>
                                                Select Exit Intent
                                            </button>
                                        )}

                                        {canShowRearrange && (
                                            <button
                                                type="button"
                                                className={`tab-button ${activeAccordion.includes(rearrangeEventKey) ? 'active' : ''}`}
                                                onClick={() => setActiveAccordion([rearrangeEventKey])}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 18 18" fill="currentColor" className="tab-icon" aria-hidden="true">
                                                    <g clipPath="url(#lpoClipRearrangeTab)">
                                                        <path d="M1.125 2.25H13.5H1.125ZM1.125 15.75H13.5H1.125ZM4.5 9H16.875H4.5Z" fill="currentColor" />
                                                        <path d="M1.125 2.25H13.5M1.125 15.75H13.5M4.5 9H16.875" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="lpoClipRearrangeTab">
                                                            <rect width="18" height="18" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                Rearrange Sections
                                            </button>
                                        )}

                                        <button
                                            type="button"
                                            className={`tab-button ${activeAccordion.includes(previewEventKey) ? 'active' : ''}`}
                                            onClick={() => setActiveAccordion([previewEventKey])}
                                        >
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="tab-icon" aria-hidden="true">
                                                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                            </svg>
                                            Generate Preview
                                        </button>

                                        <button
                                            type="button"
                                            className={`tab-button ${activeAccordion.includes(bulkApplyEventKey) ? 'active' : ''}`}
                                            onClick={() => setActiveAccordion([bulkApplyEventKey])}
                                        >
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="tab-icon" aria-hidden="true">
                                                <path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z" />
                                            </svg>
                                            Bulk Apply
                                        </button>
                                    </div>

                                    <div className="tab-content">
                                        <Accordion className="ccp-accordion" activeKey={activeAccordion}
                                                   onSelect={(keys) => setActiveAccordion(keys)}>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            <div className="ccp-accordion-header-inner">
                                                <div className="ccp-accordion-header-left">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="ccp-section-icon" aria-hidden="true">
                                                        <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                                                    </svg>
                                                    <span className="ccp-accordion-header-title">Select Targeting and Modify Content</span>
                                                </div>
                                                <span className={`ccp-accordion-chevron ${activeAccordion.includes('0') ? 'open' : ''}`} aria-hidden="true">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>

                                            {(keyword_level_data && keyword_level_data.length > 0) &&
                                                <Row className='justify-content-md-left' lg={2} xs={1}>
                                                    <Col className='p-2'>
                                                        <Label className="charts_filter_label">Keyword</Label>
                                                        <ReMultiSelect
                                                            id="select_keyword"
                                                            className='campaign_summary_custom_section_dropdown'
                                                            closeMenuOnSelect={true}
                                                            placeholder={"Search Keyword ..."}
                                                            components={ReMultiSelectAnimated()}
                                                            menuPortalTarget={document.body}
                                                            menuPosition="fixed"
                                                            styles={dropdownStyles}
                                                            value={{
                                                                value: selected_keywords["value"],
                                                                label: (selected_keywords["value"] && selected_keywords["value"].length > 0) ? `${selected_keywords["value"][0]["keyword_text"]} (${selected_keywords["value"][0]["match_type"]} | ${selected_keywords["value"][0]["ad_group_name"]} | ${selected_keywords["value"][0]["campaign_name"]})` : ""
                                                            }}
                                                            options={all_keywords.map((val) => {
                                                                return {
                                                                    value: val["value"],
                                                                    label: `${val["value"][0]["keyword_text"]} (${val["value"][0]["match_type"]} | ${val["value"][0]["ad_group_name"]} | ${val["value"][0]["campaign_name"]})`
                                                                }
                                                            })}
                                                            onMenuOpen={() => {
                                                                console.log(selected_keywords);
                                                                setTrashKeywords(selected_keywords);
                                                                setSelectedKeywords({value: "", label: []});
                                                            }}
                                                            onMenuClose={() => {
                                                                if (trashed_keywords) {
                                                                    console.log(trashed_keywords);
                                                                    setSelectedKeywords(trashed_keywords);
                                                                    setTrashKeywords(null);
                                                                }
                                                            }}
                                                            onChange={(selected_vals) => {
                                                                setSelectedKeywords(selected_vals);
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col className='p-2 d-flex align-items-end'>
                                                        {analyze_btn_loading ?
                                                            <Button
                                                                className='d-flex align-items-center justify-content-center sxi_primary_blue_btn btn-height'
                                                                style={{fontWeight: '500'}}
                                                                disabled><Spinner animation="border"/></Button>
                                                            :
                                                            <Button
                                                                className='d-flex align-items-center justify-content-center sxi_primary_blue_btn btn-height'
                                                                style={{fontWeight: '500'}}
                                                                onClick={handleAnalyze}>Generate Suggestions</Button>
                                                        }
                                                    </Col>
                                                </Row>
                                            }

                                            {(analyze_btn_loading || find_more_variation_loading) ?
                                                <div className='d-flex align-items-center justify-content-center'
                                                     style={{height: "300px"}}>
                                                    <Spinner animation="border"/>
                                                </div>
                                                :
                                                <>
                                                    {(suggestions && suggestions.length > 0) &&
                                                        <>
                                                            <Row className='justify-content-md-left mt-3' style={{
                                                                maxHeight: "400px",
                                                                overflow: "scroll",
                                                                maxWidth: "100%"
                                                            }} lg={1} xs={1}>
                                                                <br/>
                                                                <Label className="charts_filter_label">Generated
                                                                    Suggestions</Label>
                                                                <Table responsive striped={false} bordered
                                                                       hover={false}>
                                                                    <thead>
                                                                    <tr>
                                                                        {suggestions && suggestions.length > 0 && suggestions[0].map((headerText, headerIndex) => {
                                                                            return (
                                                                                <th key={`header-sugg-${headerIndex}`}
                                                                                    style={{width: suggestionsColWidth}}>{headerText}</th>
                                                                            )
                                                                        })}
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {suggestions && suggestions.length > 1 && suggestions.slice(1).map((row, row_index) => {
                                                                        return (<tr key={`row-sugg-${row_index}`}>
                                                                            {((row && Array.isArray(row) && row.length > 0) ? row : []).map((val, col_index) => {
                                                                                return (
                                                                                    <td key={`cell-sugg-${row_index}-${col_index}`}
                                                                                        style={{width: suggestionsColWidth}}>{val}</td>
                                                                                )
                                                                            })}
                                                                        </tr>)
                                                                    })}
                                                                    </tbody>
                                                                </Table>
                                                            </Row>
                                                            <Row className='justify-content-md-left mt-1' lg={1} xs={1}>
                                                                <Col style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between"
                                                                }}>
                                                                    <Button className='sxi_primary_blue_btn btn-height'
                                                                            onClick={handleFindMoreVariations}>Find More
                                                                        Variations</Button>
                                                                    {(best_performing_asset_table_data && Object.entries(best_performing_asset_table_data).length > 0) &&
                                                                        <Button className='mx-3 sxi_primary_blue_btn btn-height'
                                                                                onClick={() => setShowTopPerformingAdCopies(!show_top_performing_ad_copies)}>Top
                                                                            Performing Ad Assets</Button>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    }
                                                    {(show_top_performing_ad_copies && best_performing_asset_table_data && Object.entries(best_performing_asset_table_data).length > 0) &&
                                                        <>
                                                            <Row className='justify-content-md-left mt-3'
                                                                    style={{
                                                                        maxHeight: "400px",
                                                                        overflow: "scroll",
                                                                        maxWidth: "100%"
                                                                    }} lg={1} xs={1}>
                                                                <br/>
                                                                <Label className="charts_filter_label">Top
                                                                    Performing Ad Assets for
                                                                    "{best_performing_asset_table_data["ad_group_name"]}"</Label>
                                                                <Table responsive striped={false} bordered
                                                                        hover={false}>
                                                                    <thead>
                                                                    <tr>
                                                                        <th style={{width: "50vw"}}>Headlines</th>
                                                                        <th style={{width: "50vw"}}>Descriptions</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {best_performing_asset_table_data["headline"].map((headline, row_index) => {
                                                                        return (
                                                                            <tr>
                                                                                <td style={{width: "50vw"}}>{headline}</td>
                                                                                <td style={{width: "50vw"}}>{best_performing_asset_table_data["description"].length > row_index ? best_performing_asset_table_data["description"][row_index] : ""}</td>
                                                                            </tr>
                                                                        )
                                                                    })}
                                                                    </tbody>
                                                                </Table>
                                                            </Row>
                                                        </>
                                                    }
                                                </>
                                            }

                                            {/* Unified content row (text + images) in original order — flex-wrap, matches CustomCampaignPersonalization */}
                                            <div style={{ marginTop: "1rem", display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "flex-start", width: "100%" }}>
                                                {contentSectionsForRow.map((section) => {
                                                    const fullIndex = campaignData.templates.customized_sections.findIndex(s => s === section);
                                                    if (section.type === 'text') {
                                                        return (
                                                            <div key={`content-text-${fullIndex}`} style={{ flex: "1 1 280px", minWidth: 0, maxWidth: "100%" }}>
                                                                <div style={{display:'flex', alignItems:'center'}}>
                                                                    <label
                                                                        htmlFor={`custom_description_${fullIndex}`}
                                                                        style={{fontWeight: "bold", display:'flex', alignItems:'center', gap:'4px'}}>
                                                                        {section.view === 'mobile' && <MobileIcon />}
                                                                        {section.label}
                                                                    </label>
                                                                    <button type="button" className="btn btn-sm btn-link" onClick={()=>toggleToolbar(fullIndex, true)} style={{textDecoration:'none', padding:"2px", marginLeft:"5px"}}>Edit</button>
                                                                </div>
                                                                <div style={{display: showToolbarMap[fullIndex] ? 'flex' : 'none', alignItems:'center', gap:'6px', marginTop:'6px'}}>
                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => execCmdOn(fullIndex, 'bold')}><strong>B</strong></button>
                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => execCmdOn(fullIndex, 'italic')}><em>I</em></button>
                                                                    <input type="color" onChange={(e)=> execCmdOn(fullIndex, 'foreColor', e.target.value)} title="Text color" style={{height:'28px', width:'28px', padding:0, border:'1px solid #ccc', borderRadius:'3px'}}/>
                                                                    <select className="form-select form-select-sm" style={{width:'auto'}} onChange={(e)=> execCmdOn(fullIndex, 'fontSize', e.target.value)} defaultValue="3">
                                                                        <option value="2">Small</option>
                                                                        <option value="3">Normal</option>
                                                                        <option value="4">Medium</option>
                                                                        <option value="5">Large</option>
                                                                    </select>
                                                                    <label style={{marginLeft:'6px', fontSize:'0.85rem'}}>
                                                                        <input type="checkbox" checked={!!applyAllMap[fullIndex]} onChange={()=>toggleApplyAll(fullIndex)} style={{marginRight:'4px'}}/> All
                                                                    </label>
                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={()=>toggleToolbar(fullIndex, false)}>Close</button>
                                                                </div>
                                                                <div
                                                                    ref={(el)=> setEditorRef(fullIndex, el)}
                                                                    contentEditable
                                                                    suppressContentEditableWarning
                                                                    onPaste={(e) => handlePaste(e, fullIndex)}
                                                                    onInput={(e)=>{
                                                                        const section = campaignData?.templates?.customized_sections?.[fullIndex];
                                                                        // const maxWords = section?.max_words || null;
                                                                        const maxWords = null;
                                                                        const textContent = e.currentTarget.innerText || e.currentTarget.textContent || '';
                                                                        const wordCount = countWords(textContent);

                                                                        if (maxWords && wordCount > maxWords) {
                                                                            // Revert to last valid HTML for this editor
                                                                            const prevHtml = previousValidHtmlRef.current[fullIndex] || '';
                                                                            e.currentTarget.innerHTML = prevHtml;
                                                                            // Move caret to end
                                                                            try {
                                                                                const range = document.createRange();
                                                                                range.selectNodeContents(e.currentTarget);
                                                                                range.collapse(false);
                                                                                const sel = window.getSelection();
                                                                                sel.removeAllRanges();
                                                                                sel.addRange(range);
                                                                            } catch (err) {}
                                                                            if (!wordLimitExceededRef.current[fullIndex]) {
                                                                                toast.error(`Max word limit of ${maxWords} exceeded for "${section?.label || 'this section'}".`);
                                                                                wordLimitExceededRef.current[fullIndex] = true;
                                                                            }
                                                                            return;
                                                                        }

                                                                        if (maxWords) {
                                                                            wordLimitExceededRef.current[fullIndex] = false;
                                                                        }

                                                                        const html = e.currentTarget.innerHTML;
                                                                        const normalizedHtml = normalizeWhitespace(html);
                                                                        let temp = [...selected_suggestion];
                                                                        temp[fullIndex] = normalizedHtml;
                                                                        setSelectedSuggestion(temp);
                                                                        previousValidHtmlRef.current[fullIndex] = normalizedHtml;
                                                                    }}
                                                                    style={{width: "100%", textWrap: 'wrap', height:'35px', overflowY: 'auto', border:'1px solid #b7b7b7', borderRadius:'4px', padding:'3px 8px', marginTop:'6px', backgroundColor:'#fff'}}
                                                                />
                                                            </div>
                                                        )
                                                    }
                if (section.type === 'img' || section.type === 'image' || section.type === 'bg_img') {
                                                        const imageUrl = selected_suggestion[fullIndex] || section.value || '';
                                                        return (
                                                            <div key={`content-img-${fullIndex}`} style={{ flex: "1 1 280px", minWidth: 0, maxWidth: "100%" }}>
                                                                <label style={{fontWeight: "bold", display:'flex', alignItems:'center', gap:'4px'}}>
                                                                    {section.view === 'mobile' && <MobileIcon />}
                                                                    {section.label}
                                                                </label>
                                                                <div
                                                                    onClick={() => openImageAssetLibrary(fullIndex)}
                                                                    title={imageUrl}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        width: "100%",
                                                                        marginTop: "0.5rem",
                                                                        padding: "0px 8px",
                                                                        border: "1px solid #b7b7b7",
                                                                        borderRadius: "4px",
                                                                        backgroundColor: "#fff",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "8px",
                                                                        minHeight: "40px"
                                                                    }}
                                                                >
                                                                    <ImageWithFallback
                                                                        image_url={imageUrl}
                                                                        fallback_url={`https://storage.googleapis.com/scalex_ai_clients_lp_sections/no_preview_available.png`}
                                                                        alt={section.label}
                                                                        image_style={{ width: "35px", height: "35px", objectFit: "cover", borderRadius: "4px", border: "1px solid #eee" }}
                                                                    />
                                                                    <span style={{ flex: 1, minWidth: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: "0.9rem" }}>
                                                                        {imageUrl || "No image selected"}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    return null;
                                                })}
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* Image sections removed as a separate accordion; merged above to keep order */}

                                    {/* New Accordion Item for Dropdown Sections */}
                                    {(is_section_personalization_enabled && campaignData && campaignData?.templates && campaignData?.templates?.customized_sections && campaignData.templates.customized_sections.filter(section => section.type === 'dropdown').length > 0) && (
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>
                                                <div className="ccp-accordion-header-inner">
                                                    <div className="ccp-accordion-header-left">
                                                        <svg width="20" height="20" viewBox="0 0 16 18" fill="currentColor" className="ccp-section-icon" aria-hidden="true">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M2.56681 0.5C2.12479 0.5 1.70086 0.675595 1.3883 0.988155C1.07574 1.30072 0.900146 1.72464 0.900146 2.16667V13.8333C0.900146 14.2754 1.07574 14.6993 1.3883 15.0118C1.70086 15.3244 2.12479 15.5 2.56681 15.5H14.2335C14.6755 15.5 15.0994 15.3244 15.412 15.0118C15.7246 14.6993 15.9001 14.2754 15.9001 13.8333V2.16667C15.9001 1.72464 15.7246 1.30072 15.412 0.988155C15.0994 0.675595 14.6755 0.5 14.2335 0.5H2.56681ZM7.56681 2.16667H2.56681V6.33333H7.56681V2.16667ZM2.56681 8H7.56681C8.00884 8 8.43276 7.8244 8.74532 7.51184C9.05788 7.19928 9.23348 6.77536 9.23348 6.33333V2.16667H14.2335V13.8333H2.56681V8Z" />
                                                        </svg>
                                                        <span className="ccp-accordion-header-title">Select Section</span>
                                                    </div>
                                                    <span className={`ccp-accordion-chevron ${activeAccordion.includes('1') ? 'open' : ''}`} aria-hidden="true">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div style={{ margin: "1rem 0.25rem", display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "flex-start", width: "100%" }}>
                                                    {(campaignData && campaignData?.templates && campaignData?.templates?.customized_sections) && 
                                                        campaignData.templates.customized_sections
                                                            .filter(section => section.type === 'dropdown')
                                                            .map((section, index) => {
                                                                // Find the actual index in the full array
                                                                const fullIndex = campaignData.templates.customized_sections.findIndex(s => s === section);
                                                                return (
                                                                    <div key={`dropdown-section-${fullIndex}`} style={{ flex: "1 1 280px", minWidth: 0, maxWidth: "100%" }}>
                                                                        <Label className="charts_filter_label" style={{display:'flex', alignItems:'center', gap:'4px'}}>
                                                                            {section.view === 'mobile' && <MobileIcon />}
                                                                            {section.label}
                                                                        </Label>
                                                                        <div className="d-flex" style={{width:"98%"}}>
                                                                            <div style={{flex: 1}}>
                                                                        <ReMultiSelect
                                                                            id="select_keyword"
                                                                            className='campaign_summary_custom_section_dropdown'
                                                                            closeMenuOnSelect={true}
                                                                            placeholder={"Search Keyword ..."}
                                                                            components={ReMultiSelectAnimated()}
                                                                            menuPortalTarget={document.body}
                                                                            menuPosition="fixed"
                                                                            styles={dropdownStyles}
                                                                            value={{
                                                                                value: selected_suggestion[fullIndex] || section.options[0].value,
                                                                                label: section.options.find(opt => opt.value === (selected_suggestion[fullIndex] || section.options[0].value))?.label || section.options[0].label
                                                                            }}
                                                                            options={section.options.map(option => ({
                                                                                value: option.value,
                                                                                label: option.label
                                                                            }))}
                                                                            onChange={(selected) => {
                                                                                handleDropdownChange(fullIndex, selected.value);
                                                                            }}
                                                                        />
                                                                            </div>
                                                                            <Button
                                                                                variant="outline-secondary"
                                                                                size="sm"
                                                                                style={{border:"1px solid #b7b7b7"}}
                                                                                onClick={() => {
                                                                                    const selectedValue = selected_suggestion[fullIndex] || section.options[0].value;
                                                                                    if (selectedValue.toLowerCase() !== 'none' && selectedValue.toLowerCase() !== 'no') {
                                                                                        const previewUrl = `https://scalex-ai-existing-div-cdn.web.app/${shop_domain}/customized_sections/${selectedValue}.html`;
                                                                                        window.open(previewUrl, '_blank');
                                                                                    }
                                                                                }}
                                                                                title="Preview Section"
                                                                            >
                                                                                &gt;
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}

                                    {/* New Accordion Item for Form Customization */}
                                    {isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form') && (
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header>
                                                <div className="ccp-accordion-header-inner">
                                                    <div className="ccp-accordion-header-left">
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="ccp-section-icon" aria-hidden="true">
                                                            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                                                        </svg>
                                                        <span className="ccp-accordion-header-title">Select Form</span>
                                                    </div>
                                                    <span className={`ccp-accordion-chevron ${activeAccordion.includes('2') ? 'open' : ''}`} aria-hidden="true">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div style={{margin: "1rem 0.25rem", overflowX: "auto", whiteSpace: "nowrap"}}>
                                                    {(campaignData && campaignData?.templates && campaignData?.templates?.customized_sections) && 
                                                        campaignData.templates.customized_sections
                                                            .filter(section => section.type === 'form')
                                                            .map((section, index) => {
                                                                // Find the actual index in the full array
                                                                const fullIndex = campaignData.templates.customized_sections.findIndex(s => s === section);
                                                                return (
                                                                    <div style={{display: "inline-block", verticalAlign: "top", width: "100%"}}>
                                                                        <Label className="charts_filter_label" style={{display:'flex', alignItems:'center', gap:'4px'}}>
                                                                            {section.view === 'mobile' && <MobileIcon />}
                                                                            {section.label}
                                                                        </Label>
                                                                        <ReMultiSelect
                                                                            id={`form_select_${index}`}
                                                                            className='campaign_summary_custom_section_dropdown'
                                                                            closeMenuOnSelect={true}
                                                                            placeholder={"Select Form..."}
                                                                            components={ReMultiSelectAnimated()}
                                                                            menuPortalTarget={document.body}
                                                                            menuPosition="fixed"
                                                                            styles={dropdownStyles}
                                                                            value={{
                                                                                value: selected_suggestion[fullIndex] || section.options[0].value,
                                                                                label: section.options.find(opt => opt.value === (selected_suggestion[fullIndex] || section.options[0].value))?.label || section.options[0].label
                                                                            }}
                                                                            options={section.options.map(option => ({
                                                                                value: option.value,
                                                                                label: option.label
                                                                            }))}
                                                                            onChange={(selected) => {
                                                                                handleDropdownChange(fullIndex, selected.value);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )
                                                            })}
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}

                                    {/* New Accordion Item for Exit Intent */}
                                    {isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent') && (
                                        <Accordion.Item eventKey="3">
                                            <Accordion.Header>
                                                <div className="ccp-accordion-header-inner">
                                                    <div className="ccp-accordion-header-left">
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="ccp-section-icon" aria-hidden="true">
                                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                        </svg>
                                                        <span className="ccp-accordion-header-title">Select Exit Intent</span>
                                                    </div>
                                                    <span className={`ccp-accordion-chevron ${activeAccordion.includes('3') ? 'open' : ''}`} aria-hidden="true">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div style={{margin: "1rem 0.25rem", overflowX: "auto", whiteSpace: "nowrap"}}>
                                                    {(campaignData && campaignData?.templates && campaignData?.templates?.customized_sections) && 
                                                        campaignData.templates.customized_sections
                                                            .filter(section => section.type === 'exit_intent')
                                                            .map((section, index) => {
                                                                // Find the actual index in the full array
                                                                const fullIndex = campaignData.templates.customized_sections.findIndex(s => s === section);
                                                                return (
                                                                    <div style={{display: "inline-block", verticalAlign: "top", width: "100%"}}>
                                                                        <Label className="charts_filter_label" style={{display:'flex', alignItems:'center', gap:'4px'}}>
                                                                            {section.view === 'mobile' && <MobileIcon />}
                                                                            {section.label}
                                                                        </Label>
                                                                        <ReMultiSelect
                                                                            id={`exit_intent_select_${index}`}
                                                                            className='campaign_summary_custom_section_dropdown'
                                                                            closeMenuOnSelect={true}
                                                                            placeholder={"Select Exit Intent..."}
                                                                            components={ReMultiSelectAnimated()}
                                                                            menuPortalTarget={document.body}
                                                                            menuPosition="fixed"
                                                                            styles={dropdownStyles}
                                                                            value={{
                                                                                value: selected_suggestion[fullIndex] || section.options[0].value,
                                                                                label: section.options.find(opt => opt.value === (selected_suggestion[fullIndex] || section.options[0].value))?.label || section.options[0].label
                                                                            }}
                                                                            options={section.options.map(option => ({
                                                                                value: option.value,
                                                                                label: option.label
                                                                            }))}
                                                                            onChange={(selected) => {
                                                                                handleDropdownChange(fullIndex, selected.value);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )
                                                            })}
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}

                                    {/* Section for Rearrange Sections */}
                                    {is_section_rearrangement_enabled && campaignData?.sections_rearrangement && (
                                        <Accordion.Item eventKey={rearrangeEventKey}>
                                            <Accordion.Header>
                                                <div className="ccp-accordion-header-inner">
                                                    <div className="ccp-accordion-header-left">
                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="ccp-section-icon" aria-hidden="true">
                                                            <g clipPath="url(#lpoClipRearrangeHeader)">
                                                                <path d="M1.125 2.25H13.5H1.125ZM1.125 15.75H13.5H1.125ZM4.5 9H16.875H4.5Z" fill="#8287FF" />
                                                                <path d="M1.125 2.25H13.5M1.125 15.75H13.5M4.5 9H16.875" stroke="#8287FF" strokeWidth="2" strokeLinecap="round" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="lpoClipRearrangeHeader">
                                                                    <rect width="18" height="18" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                        <span className="ccp-accordion-header-title">Rearrange Sections</span>
                                                    </div>
                                                    <span className={`ccp-accordion-chevron ${activeAccordion.includes(rearrangeEventKey) ? 'open' : ''}`} aria-hidden="true">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div style={{ margin: "0.25rem", overflowX: "auto", whiteSpace: "nowrap" }}>
                                                    <div className="rearrangement-scroll-row" style={{ marginTop: "0.25rem", overflowX: "auto", whiteSpace: "nowrap" }}>
                                                    { selected_rearrangement && selected_rearrangement.length > 0 ?
                                                        selected_rearrangement.map((section, index) => {
                                                            const fidPlus = `lpoRPlus${index}`;
                                                            const fidDel = `lpoRDel${index}`;
                                                            return (
                                                                <div
                                                                    key={index}
                                                                    style={{
                                                                        display: "inline-flex",
                                                                        flexDirection: "column",
                                                                        verticalAlign: "top",
                                                                        width: "33%",
                                                                        maxHeight: "300px",
                                                                        gap: "12px",
                                                                        marginBottom: "1rem",
                                                                        marginRight: "0.5rem",
                                                                        position: "relative",
                                                                        padding: "10px",
                                                                        borderRadius: "12px",
                                                                        border: "1px solid #EAECF0",
                                                                        background: "#FFFFFF",
                                                                        boxShadow: "0px 4px 32px -12px #10182833",
                                                                        boxSizing: "border-box"
                                                                    }}
                                                                >
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "0.35rem", width: "100%" }}>
                                                                        <div style={{ flex: 1, minWidth: 0 }}>
                                                                            <ReMultiSelect
                                                                                id={`rearrangement_select_${index}`}
                                                                                className='campaign_summary_custom_section_dropdown'
                                                                                closeMenuOnSelect={true}
                                                                                placeholder={"Select Rearrangement..."}
                                                                                components={ReMultiSelectAnimated()}
                                                                                menuPortalTarget={document.body}
                                                                                menuPosition="fixed"
                                                                                styles={dropdownStyles}
                                                                                value={{
                                                                                    value: section || {},
                                                                                    label: section?.section_name || "Select Section"
                                                                                }}
                                                                                options={get_rearrangement_options(campaignData)}
                                                                                onChange={(selected) => {
                                                                                    handleRearrangementChange(index, selected.value);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div style={{ display: "flex", gap: "0.35rem", flexShrink: 0 }}>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => handleAddRearrangement(index)}
                                                                                style={{ padding: "0.05rem", fontSize: "0.75rem", backgroundColor: "transparent", border: "none" }}
                                                                                title="Add section after this one"
                                                                            >
                                                                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                                                    <g filter={`url(#${fidPlus})`}>
                                                                                        <rect x="2" y="1" width="40" height="40" rx="20" fill="none"/>
                                                                                        <rect x="2.5" y="1.5" width="39" height="39" rx="19.5" stroke="#D0D5DD"/>
                                                                                        <path d="M28 21.998H23V26.998C23 27.2633 22.8946 27.5176 22.7071 27.7052C22.5196 27.8927 22.2652 27.998 22 27.998C21.7348 27.998 21.4804 27.8927 21.2929 27.7052C21.1054 27.5176 21 27.2633 21 26.998V21.998H16C15.7348 21.998 15.4804 21.8927 15.2929 21.7052C15.1054 21.5176 15 21.2633 15 20.998C15 20.7328 15.1054 20.4785 15.2929 20.2909C15.4804 20.1034 15.7348 19.998 16 19.998H21V14.998C21 14.7328 21.1054 14.4785 21.2929 14.2909C21.4804 14.1034 21.7348 13.998 22 13.998C22.2652 13.998 22.5196 14.1034 22.7071 14.2909C22.8946 14.4785 23 14.7328 23 14.998V19.998H28C28.2652 19.998 28.5196 20.1034 28.7071 20.2909C28.8946 20.4785 29 20.7328 29 20.998C29 21.2633 28.8946 21.5176 28.7071 21.7052C28.5196 21.8927 28.2652 21.998 28 21.998Z" fill="#344054"/>
                                                                                    </g>
                                                                                    <defs>
                                                                                        <filter id={fidPlus} x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                                                            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                                                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                                                            <feOffset dy="1"/>
                                                                                            <feGaussianBlur stdDeviation="1"/>
                                                                                            <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
                                                                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_223_4043"/>
                                                                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_223_4043" result="shape"/>
                                                                                        </filter>
                                                                                    </defs>
                                                                                </svg>
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => handleDeleteRearrangement(index)}
                                                                                style={{ padding: "0.05rem", fontSize: "0.75rem", backgroundColor: "transparent", border: "none" }}
                                                                                title="Delete this section"
                                                                            >
                                                                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                                                    <g filter={`url(#${fidDel})`}>
                                                                                        <rect x="2" y="1" width="40" height="40" rx="20" fill="white"/>
                                                                                        <rect x="2.5" y="1.5" width="39" height="39" rx="19.5" stroke="#D0D5DD"/>
                                                                                        <path d="M25 16.5V15.9C25 15.0599 25 14.6399 24.8365 14.319C24.6927 14.0368 24.4632 13.8073 24.181 13.6635C23.8601 13.5 23.4401 13.5 22.6 13.5H21.4C20.5599 13.5 20.1399 13.5 19.819 13.6635C19.5368 13.8073 19.3073 14.0368 19.1635 14.319C19 14.6399 19 15.0599 19 15.9V16.5M20.5 20.625V24.375M23.5 20.625V24.375M15.25 16.5H28.75M27.25 16.5V24.9C27.25 26.1601 27.25 26.7902 27.0048 27.2715C26.789 27.6948 26.4448 28.039 26.0215 28.2548C25.5402 28.5 24.9101 28.5 23.65 28.5H20.35C19.0899 28.5 18.4598 28.5 17.9785 28.2548C17.5552 28.039 17.211 27.6948 16.9952 27.2715C16.75 26.7902 16.75 26.1601 16.75 24.9V16.5" stroke="#344054" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                                                    </g>
                                                                                    <defs>
                                                                                        <filter id={fidDel} x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                                                            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                                                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                                                            <feOffset dy="1"/>
                                                                                            <feGaussianBlur stdDeviation="1"/>
                                                                                            <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
                                                                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_223_4047"/>
                                                                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_223_4047" result="shape"/>
                                                                                        </filter>
                                                                                    </defs>
                                                                                </svg>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ width: "100%", marginTop: "1rem" }}>
                                                                        <ImageWithFallback image_url={section.image_url} fallback_url={`https://storage.googleapis.com/scalex_ai_clients_lp_sections/no_preview_available.png`} alt={section.section_name} image_style={{ width: "100%", height: "auto", maxHeight: "200px" }} />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })
                                                        :
                                                        <div style={{ display: "inline-block", verticalAlign: "top", width: "33%", height: "100px", border: "1px solid #ccc", borderRadius: "5px", position: "relative" }}>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleAddRearrangement(0)}
                                                                style={{ padding: "0.05rem", fontSize: "0.75rem", backgroundColor: "transparent", border: "none", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16" aria-hidden="true">
                                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                                                </svg>
                                                                Add Section
                                                            </button>
                                                        </div>
                                                    }
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}

                                    {/* Generate Preview Accordion */}
                                    <Accordion.Item eventKey={previewEventKey}>
                                        <Accordion.Header>
                                            <div className="ccp-accordion-header-inner">
                                                <div className="ccp-accordion-header-left">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="ccp-section-icon" aria-hidden="true">
                                                        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                                    </svg>
                                                    <span className="ccp-accordion-header-title">Generate Preview</span>
                                                </div>
                                                <span className={`ccp-accordion-chevron ${activeAccordion.includes(previewEventKey) ? 'open' : ''}`} aria-hidden="true">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Row className='justify-content-md-left my-2' lg={2} xs={1}>
                                                <Col style={{textAlign: "left"}}>
                                                    {generate_btn_loading ?
                                                        <Button className='mt-3 sxi_primary_blue_btn btn-height'
                                                                disabled><Spinner size="sm"
                                                            animation="border"/></Button>
                                                        :
                                                        <>
                                                            <Button
                                                                className='mt-3 sxi_primary_blue_btn btn-height'
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleSaveDescriptionToSheet(true)
                                                                }}>Generate Preview</Button>
                                                        </>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className='justify-content-md-left mb-3' lg={1} xs={1}>
                                                {(show_landing_page && !generate_btn_loading) &&
                                                    <>
                                                        <div className='py-4 mt-4' style={{
                                                            width: "100%",
                                                            backgroundColor: "white",
                                                            color: "black",
                                                            borderRadius: "5px"
                                                        }}>
                                                            Landing Page URL (Open in incognito mode) -
                                                            <br/>
                                                            {(selected_keywords && selected_keywords["value"]) && selected_keywords["value"].map((val) => {
                                                                let updated_exp_url = `${campaignData.landing_page_urls}?sxi_content=${generate_preview_contentKey}`;
                                                                return (
                                                                    <>
                                                                        <Link
                                                                            to={encodeURI(updated_exp_url)}
                                                                            target='_blank'>{encodeURI(`${updated_exp_url}`)}</Link>
                                                                        <br/>
                                                                    </>
                                                                )
                                                            })}
                                                            {/* <br/>
                                                            <br/>
                                                            Spreadsheet Url - <Link to={spreadsheet_url}
                                                                                    target='_blank'>{spreadsheet_url}</Link> */}
                                                        </div>
                                                    </>
                                                }
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey={bulkApplyEventKey}>
                                        <Accordion.Header>
                                            <div className="ccp-accordion-header-inner">
                                                <div className="ccp-accordion-header-left">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="ccp-section-icon" aria-hidden="true">
                                                        <path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z" />
                                                    </svg>
                                                    <span className="ccp-accordion-header-title">Bulk Apply</span>
                                                </div>
                                                <span className={`ccp-accordion-chevron ${activeAccordion.includes(bulkApplyEventKey) ? 'open' : ''}`} aria-hidden="true">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Row className='justify-content-md-left mt-3' lg={1} xs={1}>
                                                <Col className='p-2'>
                                                    <Label className="charts_filter_label">Select keywords/match
                                                        types/campaigns/adgroups to bulk publish</Label>
                                                    <MultiSelect
                                                        id="select_keyword_bulk_apply"
                                                        className='campaign_summary_custom_section_dropdown'
                                                        valueRenderer={() => {
                                                            if (bulk_apply_selected_keywords.length === 0) return "Select...";
                                                            return `${bulk_apply_selected_keywords.length} item${bulk_apply_selected_keywords.length > 1 ? 's' : ''} selected`;
                                                        }}
                                                        value={bulk_apply_selected_keywords.map((val) => {
                                                            return {
                                                                value: val["value"],
                                                                label: `${val["value"][0]["keyword_text"]} (${val["value"][0]["match_type"]} | ${val["value"][0]["ad_group_name"]} | ${val["value"][0]["campaign_name"]})`
                                                            }
                                                        })}
                                                        options={all_keywords.map((val) => {
                                                            return {
                                                                value: val["value"],
                                                                label: `${val["value"][0]["keyword_text"]} (${val["value"][0]["match_type"]} | ${val["value"][0]["ad_group_name"]} | ${val["value"][0]["campaign_name"]})`
                                                            }
                                                        })}
                                                        onChange={(selected_vals) => {
                                                            setBulkApplySelectedKeywords(selected_vals);
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                            {(bulk_apply_selected_keywords && bulk_apply_selected_keywords.length > 0) &&
                                                <>
                                                    <Row className='justify-content-md-left mt-3' lg={1} xs={1}>
                                                        <br/>
                                                        <Label className="charts_filter_label">Bulk Apply
                                                            Preview</Label>
                                                        <div id='kio_bulk_apply_table' style={{
                                                            maxHeight: "400px",
                                                            overflow: "scroll",
                                                            maxWidth: "100%"
                                                        }}>
                                                            <Table responsive striped={false} bordered hover={false}>
                                                                <thead>
                                                                <tr>
                                                                    <th style={{width: "20vw"}}>Keyword</th>
                                                                    <th style={{width: "10vw"}}>Match Type</th>
                                                                    <th style={{width: "30vw"}}>Ad Group Name</th>
                                                                    <th style={{width: "30vw"}}>Campaign Name</th>
                                                                    <th style={{width: "30vw"}}>Preview URL 
                                                                        <on_hover_tooltip title="The preview URL will only show the variation if both the campaign and the variant are live and enabled."><svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="grey" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                            <circle cx="12" cy="12" r="10" />
                                                                            <line x1="12" y1="16" x2="12" y2="12" />
                                                                            <line x1="12" y1="8" x2="12.01" y2="8" />
                                                                        </svg></on_hover_tooltip>
                                                                    </th>
                                                                    <th style={{width: "10vw"}}></th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {bulk_apply_selected_keywords.map((val, idx) => {
                                                                    return (<tr>
                                                                        <td style={{width: "20vw"}}>{val["value"][0]["keyword_text"]}</td>
                                                                        <td style={{width: "10vw"}}>{val["value"][0]["match_type"]}</td>
                                                                        <td style={{width: "30vw"}}>{val["value"][0]["ad_group_name"]}</td>
                                                                        <td style={{width: "30vw"}}>{val["value"][0]["campaign_name"]}</td>
                                                                        <td style={{width: "30vw"}}><a href={encodeURI(campaignData.landing_page_urls + "?sxi_content=" + val["value"][0]["campaign_id"] +"-"+ val["value"][0]["ad_group_id"]+"-"+ val["value"][0]["keyword_text"]+"-"+getMatchTypeLetter(val["value"][0]["match_type"]))} target='_blank'>Preview</a></td>
                                                                        <td style={{width: "10vw", cursor: "pointer"}}
                                                                            onClick={() => {
                                                                                let temp_bulk_apply_selected_keywords = [...bulk_apply_selected_keywords]
                                                                                temp_bulk_apply_selected_keywords.splice(idx, 1)
                                                                                setBulkApplySelectedKeywords(temp_bulk_apply_selected_keywords)
                                                                            }} src={delete_icon} alt='delete' width={20}
                                                                            height={20}><span
                                                                            style={{color: "grey"}}>&#128465;</span>
                                                                        </td>
                                                                    </tr>)
                                                                })}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </Row>
                                                </>
                                            }
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>

                                    <div className="bottom-actions">
                                        {(() => {
                                            const visibleTabs = getVisibleTabs();
                                            const activeTabKey = activeAccordion?.[0] ?? '0';
                                            const currentIndex = visibleTabs.indexOf(activeTabKey);

                                            const isPrevDisabled = currentIndex <= 0;
                                            const isNextDisabled = currentIndex < 0 || currentIndex >= visibleTabs.length - 1;

                                            return (
                                                <>
                                                    <div className="actions-left">
                                                        <button
                                                            type="button"
                                                            className="btn-secondary"
                                                            onClick={() => {
                                                                if (currentIndex > 0) {
                                                                    setActiveAccordion([visibleTabs[currentIndex - 1]]);
                                                                }
                                                            }}
                                                            disabled={isPrevDisabled}
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="btn-icon" aria-hidden="true">
                                                                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                                            </svg>
                                                            Previous
                                                        </button>
                                                    </div>

                                                    <div className="actions-right">
                                                        <button
                                                            type="button"
                                                            className="btn-primary"
                                                            onClick={() => {
                                                                if (currentIndex >= 0 && currentIndex < visibleTabs.length - 1) {
                                                                    setActiveAccordion([visibleTabs[currentIndex + 1]]);
                                                                }
                                                            }}
                                                            disabled={isNextDisabled}
                                                        >
                                                            Next
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="btn-icon" aria-hidden="true">
                                                                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </>
                                            );
                                        })()}
                                    </div>
                                    </div>
                                </div>
                            </Container>

                            <div className="save-back-row">
                                <div className="actions-left">
                                    {apply_customization_btn_loading ?
                                        <Button className='sxi_primary_blue_btn btn-height' disabled><Spinner size="sm" animation="border"/></Button>
                                        :
                                        <Button className='sxi_primary_blue_btn btn-height' onClick={(e) => { e.preventDefault();
                                            setApplyCustomizeBtnLoading(true);
                                            handleSaveDescriptionToSheet(false) }}>Save and Return</Button>
                                    }
                                    <button
                                        type="button"
                                        className="back-button btn-height"
                                        onClick={handleBack}
                                    >
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="btn-icon" aria-hidden="true">
                                            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                        </svg>
                                        Back
                                    </button>
                                </div>
                            </div>

                            {/* Image Asset Library Modal */}
                            <Modal show={showImageLibrary} onHide={() => setShowImageLibrary(false)} size="lg">
                                <Modal.Header closeButton>
                                    <Modal.Title>Select Image</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {imageAssetsLoading ?
                                        <div className='main_conatiner_spinner'>
                                            <Spinner animation="border"/>
                                        </div>
                                        :
                                        <div className="row">
                                            {imageAssets && imageAssets.length > 0 ? imageAssets.map((asset) => {
                                                const previewUrl = getFilePreviewUrl(asset);
                                                return (
                                                    <div className="col-md-4 mb-3" key={asset._id}>
                                                        <div className="card h-100" style={{cursor:'pointer'}} onClick={() => handleSelectImageAsset(asset)}>
                                                            <img src={previewUrl} alt={asset.title} style={{width:'100%', height:'150px', objectFit:'cover'}}/>
                                                            <div className="card-body">
                                                                <div style={{fontSize:'0.85rem', fontWeight:600}}>{asset.title}</div>
                                                                <div style={{fontSize:'0.75rem', color:'#666'}}>Type: Image</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }) : (
                                                <div className="col-12">
                                                    <div className="text-muted">No images found in assets.</div>
                                                </div>
                                            )}
                                        </div>
                                    }
                                </Modal.Body>
                            </Modal>
                        </>
                        :
                        <div className='main_conatiner_spinner'>
                            <Spinner animation="border"/>
                        </div>
                    }
                </>
            }
        </div>
    )

}

export default LandingPageOptimization


function get_all_keywords(keyword_level_data) {
    var res = alasql(`SELECT *
                      FROM ?
                      ORDER BY keyword_text DESC`, [keyword_level_data]);
    res = alasql(`SELECT ARRAY(DISTINCT keyword_text) as all_keywords
                  FROM ?`, [res]);
    console.log(res[0]["all_keywords"]);
    return res[0]["all_keywords"];
}

function get_all_keywords_for_analysis_section(keyword_level_data) {
    var res = alasql(`SELECT *
                      FROM ?
                      ORDER BY keyword_text DESC`, [keyword_level_data]);
    // Map each record to the desired string format
    var combined_json = [];
    // Single Value for all
    res.forEach(row => {
            combined_json.push({
                "label": row["keyword_text"],
                "value": [{
                    "campaign_id": row.campaign_id,
                    "campaign_name": row.campaign_name,
                    "ad_group_id": row.ad_group_id,
                    "ad_group_name": row.ad_group_name,
                    keyword_text: row.keyword_text,
                    match_type: row.match_type
                }]
            })
        }
    );

    // Remove duplicates if needed
    var uniqueCombinedStrings = [...new Set(combined_json)];

    return uniqueCombinedStrings;
}


function check_loc_personalization(query) {
    const pattern = /\{\s*(\w+)?\s*(sxi_city|sxi_zipcode)(?:\s*:\s*([^}]+))?\s*\}/i;

    const match = query.match(pattern);

    if (match) {
        const key = match[2];
        return {
            is_loc_personalized: true,
            loc_personalization_type: key === "sxi_city" ? "city" : "zip_code"
        };
    } else {
        return {
            is_loc_personalized: false,
            loc_personalization_type: null
        };
    }
}

function get_rearrangement_options(campaignData) {
    let rearrangement_options = [];
    let sections_rearrangement = campaignData?.sections_rearrangement || [];
    sections_rearrangement.forEach(option_iter => {
        rearrangement_options.push({
            value: option_iter,
            label: option_iter.section_name || "Section"
        })
    })
    let approved_sections = campaignData?.approved_sections || [];
    approved_sections.forEach(option_iter => {
        rearrangement_options.push({
            value: option_iter,
            label: "(SXI) " + (option_iter.section_name || "Section")
        })
    })
    return rearrangement_options
}

// Used to format Date in yyyy-mm-dd format
function formatDate(date, is_increase_date = false) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + (is_increase_date ? d.getDate() + 1 : d.getDate()),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

function createClientScreenshotDir(clientName, landingUrl) {
    // Sanitize URL for folder name
    const sanitizedUrl = sanitizeUrlForFolder(landingUrl);
    // Return a URL path instead of creating directories (browser environment)
    return `${clientName}/${sanitizedUrl}`;
}

function sanitizeUrlForFolder(url) {
    // Remove @ prefix if present
    let cleanUrl = url.startsWith('@') ? url.substring(1) : url;
    
    // Remove protocol (http://, https://)
    cleanUrl = cleanUrl.replace(/^https?:\/\//, '');
    
    // Replace invalid characters with underscores (browser-safe characters)
    cleanUrl = cleanUrl.replace(/[<>:"/\\|?*]/g, '_');
    
    // Remove trailing dots and spaces
    cleanUrl = cleanUrl.replace(/\.+$/, '').trim();
    
    // Ensure it's not empty
    if (!cleanUrl) {
      cleanUrl = 'default_url';
    }
    
    return cleanUrl;
}